import { render } from "./MainMenu.vue?vue&type=template&id=5ac5ecdb&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=5ac5ecdb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ac5ecdb"

export default script